export class ClientStorage {
	#storage;

	/**
	 * @param {globalThis.Storage} storage
	 */
	constructor(storage) {
		this.#storage = storage;
	}

	/**
	 * @param {string} key
	 * @returns {string | null}
	 */
	get(key) {
		try {
			return this.#storage.getItem(key);
		} catch {
			// Ignore quota-related exceptions.
			return null;
		}
	}

	/**
	 * @param {string} key
	 * @param {string} value
	 */
	set(key, value) {
		try {
			this.#storage.setItem(key, value);
		} catch {
			// Ignore quota-related exceptions.
		}
	}

	/**
	 * @param {string} key
	 */
	remove(key) {
		try {
			this.#storage.removeItem(key);
		} catch {
			// Ignore quota-related exceptions.
		}
	}
}
